import React from "react";
import NavBar from "../Components/NavBar/NavBar";
import Footer from "../Components/Footer/Footer";
import { Helmet } from "react-helmet";

const StaffingSolutions = () => {
  return (
    <>
      <Helmet>
        <title>IT Staffing Solutions - Dhanam Information Systems</title>
        <meta
          name="description"
          content="Dhanam provides global, on-demand skilled IT staffing solutions. Hire developers, QA engineers, cloud experts, and project managers efficiently."
        />
      </Helmet>

      <NavBar />

      <div className="about-hero py-5 text-white text-center">
        <div className="container">
          <h1>On-Demand Skilled IT Staffing Solutions</h1>
          <p className="lead">
            Flexible Talent. Global Reach. Fast Deployment.
          </p>
        </div>
      </div>

      <div className="container py-5">
        <p>
          At <strong>Dhanam Information Systems</strong>, we provide agile and
          reliable IT staffing solutions to help organizations fill talent
          gaps, scale teams quickly, and meet project goals efficiently.
          Whether you need a single expert or an entire project team, we
          connect you with certified, pre-vetted IT professionals across
          development, testing, management, infrastructure, and network
          domains.
        </p>

        <h5 className="mt-4 mb-3 text-primary">🔹 Our IT Staffing Capabilities Include:</h5>
        <ul className="mb-4">
          <li>
            <strong>Software Developers:</strong> Skilled in full-stack,
            mobile, backend, cloud-native, and legacy platforms (Java, .NET,
            React, Python, Node.js, etc.)
          </li>
          <li>
            <strong>QA & Test Engineers:</strong> Experts in manual testing,
            automation (Selenium, Cypress), performance testing, and test
            management tools.
          </li>
          <li>
            <strong>Project & Delivery Managers:</strong> Experienced in
            Agile/Scrum, PMP-certified leaders who drive success across
            timelines, budgets, and teams.
          </li>
          <li>
            <strong>Cloud & DevOps Engineers:</strong> Certified AWS, Azure,
            and GCP professionals who streamline CI/CD, IaaS, automation, and
            cloud operations.
          </li>
          <li>
            <strong>Infrastructure & Network Engineers:</strong> Specialists in
            system administration, server management, virtualization, and
            secure enterprise networks.
          </li>
          <li>
            <strong>Support & Helpdesk Professionals:</strong> Tier 1–3 support
            engineers for global helpdesk, IT service management (ITSM), and
            end-user support.
          </li>
        </ul>

        <h5 className="mb-3 text-primary">🔹 Why Choose Dhanam for IT Staffing?</h5>
        <ul className="mb-4">
          <li>Global talent pool available on-demand</li>
          <li>Short-term, long-term, and contract-to-hire flexibility</li>
          <li>Rapid onboarding and seamless integration into your teams</li>
          <li>Deep domain knowledge across industries and tech stacks</li>
          <li>Cost-effective resourcing with zero compromise on quality</li>
        </ul>

        <h5 className="text-success fw-bold">Scale smarter, not harder.</h5>
        <p>
          Let <strong>Dhanam Information Systems</strong> be your trusted IT
          staffing partner — delivering the right talent, at the right time,
          anywhere in the world.
        </p>
      </div>

      <Footer />

      <style jsx>{`
        .about-hero {
          background-color: rgb(11, 22, 63);
        }

        ul {
          list-style: none;
          padding-left: 0;
        }

        ul li::before {
          margin-right: 10px;
          color: green;
        }
      `}</style>
    </>
  );
};

export default StaffingSolutions;
